import { RESET_STATE } from 'store/global/actions';

import { TASKS_SLA_GROUP_ACTION_TYPE } from '../actions';

const initialState = {};

const tasksReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TASKS_SLA_GROUP_ACTION_TYPE.GET_TASK_SLA_GROUPS_BY_APPLICATION_ID:
      return payload || initialState;

    case TASKS_SLA_GROUP_ACTION_TYPE.GET_TASK_SLA_GROUP:
      return { ...state, [payload.id]: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default tasksReducer;
